<template>
  <div class="message">
    <div class="t-nav">
      <nav>
        <ul class="r-nav">
          <li :class="[isActive===''?'active':'']"  @click="message('')"><a href="javascript:void(0);">我的消息</a></li>
          <li :class="[isActive==='trade'?'active':'']"  @click="message('trade')"><a href="javascript:void(0);">交易动态</a></li>
          <li :class="[isActive==='activity'?'active':'']" @click="message('activity')"><a href="javascript:void(0);">活动通知</a></li>
          <li :class="[isActive==='system'?'active':'']" @click="message('system')"><a href="javascript:void(0);">系统消息</a></li>
        </ul>
      </nav>
    </div>
    <el-table
      :data="tableData"
      stripe
      style="width: 100%"
      class="messagelist">
      <el-table-column
        label="类型"
        width="340">
        <template slot-scope="scope">
          <i class="el-icon-s-order"></i>
          <a href="#">{{ scope.row.title }}</a>
        </template>
      </el-table-column>
      <el-table-column
        prop="create_date"
        label="时间"
        width="130">
      </el-table-column>
      <el-table-column
        prop="content"
        label="备注"
        align="center"
        >
      </el-table-column>
    </el-table>
    <div class="pages" v-if="total>pageSize">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-sizes="[5, 10, 15, 20]"
        :page-size.sync ="pageSize"
        background
        layout="total,sizes, prev, pager, next"
        :total="total">
      </el-pagination>
    </div>
  </div>
</template>
<script>
import eventBus from '../../common/eventBus.js'
export default {
  name: 'message',
  components: {
  },
  created () {
    if (this.$route.params.type) {
      this.message(this.$route.params.type)
    } else {
      this.messageList()
    }

    eventBus.$on('showMessage', type => {
      this.message(type)
    })
  },
  data () {
    return {
      currentPage: 1,
      total: 0,
      pageSize: 5,
      type: '',
      isActive: '',
      tableData: []
    }
  },
  methods: {
    message(type) {
      this.type = type
      this.isActive = type
      this.messageList()
    },
    messageList() {
      let queryParams = {
        currentPage: this.currentPage,
        pageSize: this.pageSize,
        type: this.type
      }
      this.sapost('/dmc/account/message', queryParams, r => {
        let { retMsg, retCode, pager } = r.data
        if (retCode === '0') {
          this.total = pager.total
          this.pageSize = pager.pageSize
          this.tableData = pager.list
        } else {
          if (retMsg === '用户未登录！') {
            eventBus.$emit('logout')
          }
          this.$message.warning(retMsg)
        }
      })
    },
    handleSizeChange (val) {
      this.pagesize = val
      console.log(`每页 ${val} 条`)
      this.messageList()
    },
    handleCurrentChange (val) {
      this.currentPage = val
      console.log(`当前页: ${val}`)
      this.messageList()
    }
  }
}
</script>

<style lang="less" scoped>
.message{
  margin-left: 200px;
  padding-left: 30px;
  background-color: #fff;
  .t-nav {
    nav{
      border-bottom: 2px solid #ddd;
      ul {
        margin-right: 150px;
        height: 60px;
        color: #b4b8bb;
        li{
          float: left;
          height: 60px;
          line-height: 60px;
          font-size: 15px;
          margin-right: 45px;
          a{
            color:#b4b8bb;
          }
          cursor: pointer;
        }
        li.active {
          border-bottom: 2px solid #f01400;
          a{
            color:#f01400;
          }
        }
        li:hover {
          border-bottom: 2px solid #f97575;
          a{
            color:#f97575;
          }
        }
      }
    }
  }
  .r-title{
    float: right;
    height: 60px;
    line-height: 60px;
    span{
      color: #f01400;
    }
  }
  .pages{
    text-align: right;
    padding-top: 15px;
  }
  .messagelist {
    .el-table--enable-row-hover .el-table__body tr:hover>td{
      background-color:#fef3f3;
    }
    .el-icon-s-order{
      font-size: 18px;
      margin-right: 5px;
      color: #ffb632;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/page/userCenter/message.vue